import React from 'react'
import { Outlet } from 'react-router-dom'

import NotFound from '../pages/notFound/NotFound'
import { permissions } from '../utils/constants/permissions'
import { hasPermission } from '../utils/helpers/hasPermission'

type props = {
  permission: permissions | undefined
}

const RequirePermission: React.FC<props> = ({ permission }) => {
  if (!permission) return <Outlet />

  if (hasPermission(permission)) {
    return <Outlet />
  }
  return <NotFound />
}

export default RequirePermission
